import { FilterValuesObj, IExtractFilterValue, IFilterValue } from './interfaces';

export enum FilterValueKey {
  CALCULATION_RESULT = 'calculationResult',
  SUPPLY_PRESSURE = 'supplyPressure',
  OUTPUT_PRESSURE = 'outputPressure',
  TUBING_LENGTH = 'tubingLength',
  INTERNAL_DIAMETER = 'internalDiameter',
  DISCHARGE = 'discharge',
}

export const filterKeys = Object.values(FilterValueKey);

const extractFilterValue = ({ value }: IExtractFilterValue) => {
  if (Array.isArray(value)) {
    let savedData: string | number = '';
    value.forEach((val) => {
      if (val.selected) {
        savedData = val.data;
      }
    });
    return savedData;
  } else {
    return value.data;
  }
};

export const prepareFilterValues = ({ filters }: IFilterValue): FilterValuesObj[] => {
  const arrayOfFiltersValue: FilterValuesObj[] = [];

  filters.forEach((filter) => {
    if (filter.value) {
      arrayOfFiltersValue.push({
        [filter.key]: extractFilterValue({ value: filter.value }),
      });
    } else if (!filter.value && filter.filters) {
      filter.filters.map((subFilter) => {
        if (!subFilter.value) return null;

        arrayOfFiltersValue.push({
          [subFilter.key]: extractFilterValue({ value: subFilter.value }),
        });

        return null;
      });
    }
  });
  return arrayOfFiltersValue;
};
